



import Vue from 'vue'
import symptoms from '@/components/symptoms.vue';
//import Tags from '@/components/TagsNew.vue';

export default Vue.extend({
     props:['business','tag'],
    components:{
        symptoms,
    },
    watch:{
        business:function(value)
        {
            return value;
        },
         tag:function(value)
        {
            return value;
        },
    }
})
